/**
 * price-utils.js - Shared price formatting utilities
 * DRY: Used by bundle selectors and product.js
 * Single Responsibility: Price formatting only
 */
var PriceUtils = (function() {
  'use strict';

  /**
   * Parse price with validation and fallback
   * @param {string|number} value - Price value to parse
   * @param {number} defaultValue - Fallback value if invalid
   * @returns {number} Parsed price in cents
   */
  function parsePrice(value, defaultValue) {
    if (defaultValue === undefined) defaultValue = 0;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? defaultValue : parsed;
  }

  /**
   * Format price using shop money format
   * @param {number|string} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatPrice(cents) {
    if (!cents && cents !== 0) return '';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseFloat(cents) / 100;

    const currency = document.documentElement.getAttribute('data-currency') ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      '';
    const iso = currency.toUpperCase();
    if (iso === 'EUR') {
      let eur = value.toFixed(2).replace('.', ',');
      if (eur.endsWith(',00')) eur = eur.slice(0, -3);
      return `${eur} €`;
    }
    const symbols = { USD: '$', CAD: '$', AUD: '$', NZD: '$', GBP: '£' };
    if (symbols[iso]) {
      let amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (amount.endsWith('.00')) amount = amount.slice(0, -3);
      return `${symbols[iso]}${amount}`;
    }
    
    const meta = document.querySelector('meta[name="money-format"]');
    const formatString = meta ? meta.getAttribute('content') : '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    
    if (!match) return formatString;
    
    const placeholder = match[1];
    let formattedValue;
    
    switch (placeholder) {
      case 'amount':
        formattedValue = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_no_decimals':
        formattedValue = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        formattedValue = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        formattedValue = value.toFixed(2);
    }
    
    return formatString.replace(placeholderRegex, formattedValue);
  }

  /**
   * Calculate discount percentage
   * @param {number} comparePrice - Original price
   * @param {number} price - Sale price
   * @returns {number} Discount percentage (0-100)
   */
  function calculateDiscount(comparePrice, price) {
    if (!comparePrice || !price || comparePrice <= price) return 0;
    return Math.round(((comparePrice - price) / comparePrice) * 100);
  }

  return {
    parsePrice: parsePrice,
    formatPrice: formatPrice,
    calculateDiscount: calculateDiscount
  };
})();
